function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import { ICheckbox } from '../Checkbox';
require("./Checkbox-Control.css");
var styles = {
  "Root": "Checkbox-Control-module-Root_2BH"
};
export const CheckboxControl = ({
  onChange,
  name,
  disabled,
  checked = false,
  tabIndex = 0,
  autoFocus = false,
  controlRef,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: styles.Root,
    onChange: onChange,
    name: name,
    disabled: disabled,
    defaultChecked: checked,
    tabIndex: tabIndex,
    autoFocus: autoFocus,
    ref: controlRef
  }, props));
};